import script from "./GlobalAtmosphere.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalAtmosphere.vue?vue&type=script&setup=true&lang=ts"

import "./GlobalAtmosphere.vue?vue&type=style&index=0&id=e95f941a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e95f941a"]])

export default __exports__